import React from 'react'
import { AlertCircle, RefreshCw, X } from 'lucide-react'

const ErrorMessage = ({ 
  error, 
  onRetry, 
  onDismiss, 
  title = "Erreur de chargement", 
  showRetry = true,
  showDismiss = false,
  className = "" 
}) => {
  if (!error) return null

  const getErrorMessage = (error) => {
    if (typeof error === 'string') return error
    if (error?.message) return error.message
    if (error?.response?.data?.detail) return error.response.data.detail
    if (error?.response?.statusText) return error.response.statusText
    return "Une erreur inattendue s'est produite"
  }

  const getErrorCode = (error) => {
    if (error?.response?.status) return error.response.status
    if (error?.code) return error.code
    return null
  }

  return (
    <div className={`bg-red-50 dark:bg-red-950/30 border-l-4 border-red-400 dark:border-red-600 p-4 rounded-lg ${className}`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-red-400 dark:text-red-500" />
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-red-800 dark:text-red-300">
            {title}
            {getErrorCode(error) && (
              <span className="ml-2 text-xs bg-red-200 text-red-700 px-2 py-0.5 rounded">
                {getErrorCode(error)}
              </span>
            )}
          </h3>
          <div className="mt-2 text-sm text-red-700 dark:text-red-400">
            {getErrorMessage(error)}
          </div>
          {(showRetry || showDismiss) && (
            <div className="flex space-x-3">
              {showRetry && onRetry && (
                <button
                  type="button"
                  onClick={onRetry}
                  className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-red-700 dark:text-red-300 bg-red-100 dark:bg-red-900/40 hover:bg-red-200 dark:hover:bg-red-900/60 transition-colors"
                >
                  <RefreshCw className="h-3.5 w-3.5 mr-1" />
                  Réessayer
                </button>
              )}
              {showDismiss && onDismiss && (
                <button
                  type="button"
                  onClick={onDismiss}
                  className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                >
                  <X className="h-3.5 w-3.5 mr-1" />
                  Fermer
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ErrorMessage
